
    import './styles.scoped.css';
    export default {
  "sticky-notifications": "awsui_sticky-notifications_154bi_es3m6_5",
  "sticky-notifications-with-background": "awsui_sticky-notifications-with-background_154bi_es3m6_9",
  "has-notifications-content": "awsui_has-notifications-content_154bi_es3m6_13"
};
  